export default "__VITE_PUBLIC_ASSET__4f999ba3__"